export default __webpack_public_path__ + "static/media/daniel.e9a28157.jpg";